import { styled } from "@mui/material";

const CircularContainer = styled('div')(({theme, padding = '0.5rem'}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: '100%',
    padding: padding
}));

export default CircularContainer;